















































import Vue from 'vue';
import { countries } from '@/data/countries';
import { ICountry } from '@/models/country';
import { getPropertyFromItem } from '@/utils/helpers';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    autocompleteRef: {
      reset: () => void;
    } & Vue;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'CountryPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Array, String, Object],

    countries: {
      type: Array as () => ICountry[],
      default: () => countries()
    },

    itemText: {
      type: String,
      default: 'name'
    },

    itemValue: {
      type: String,
      default: 'code'
    },

    label: {
      type: String,
      default: 'Countries'
    },

    multiple: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      lazyValue:
        this.value !== undefined ? this.value : this.multiple ? [] : undefined,
      search: ''
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      }
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    selectedAllCountries(): boolean {
      return (
        Array.isArray(this.internalValue) &&
        this.internalValue.length === this.countries.length
      );
    },

    selectedSomeCountries(): boolean {
      return (
        Array.isArray(this.internalValue) &&
        this.internalValue.length > 0 &&
        !this.selectedAllCountries
      );
    },

    icon(): string {
      if (this.selectedAllCountries) return 'mdi-close-box';
      if (this.selectedSomeCountries) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },

  methods: {
    /** @public */
    reset() {
      if (this.$refs.autocompleteRef) {
        this.$refs.autocompleteRef.reset();
      }
    },

    selectAllCountries(countries: ICountry[]) {
      this.$nextTick(() => {
        if (this.selectedAllCountries) {
          this.internalValue = [];
        } else {
          this.internalValue = countries.map(this.getValue);
        }
      });
    },

    getText(item: ICountry) {
      return getPropertyFromItem(item, this.itemText, item);
    },

    getValue(item: ICountry) {
      if (this.$attrs.returnObject) return item;
      return getPropertyFromItem(item, this.itemValue, this.getText(item));
    }
  }
});
